/**
 * @Author : ShaJiaJing
 * @Date : 2019/6/4
 * @Version : 1.0
 * @Content : 用户配置
 */
export default {
  common: {
    action: 'Action',
    operation: 'Operation',
    startDate: 'startDate',
    endDate: 'endDate',
    input: 'input placeholder',
    details: 'Details',
    expireDate: 'Expire date',
    robot: 'Robot',
    status: 'status',
    all: 'All',
    today: 'Today',
    yesterday: 'Yesterday',
    lastWeek: 'Last Week',
    lastThirty: 'Last Thirty',
    echarts: 'echarts',
    back: 'back'
  },
  actions: {
    confirm: 'Confirm',
    detail: 'Details',
    cancel: 'Cancel',
    delete: 'Delete | Batch Deletion',
    modify: 'Modify',
    create: 'Create',
    check: 'Check',
    search: 'Search | Query List | Query Single',
    clear: 'Clear | Clear All',
    more: 'More',
    login: 'Login',
    logout: 'Logout',
    start: 'Start',
    stop: 'Stop',
    bind: 'Bind',
    unbind: 'Unbind',
    export: 'Export',
    upload: 'Upload',
    retry: 'Retry',
    unknown: 'Unknown'
  },
  // 消息列表
  message: {
    title: 'Message List',
    level: 'Level',
    module: 'Module',
    content: 'Content',
    status: 'Status',
    time: 'Time',
    date: 'Date',
    levels: {
      all: 'All',
      info: 'Info',
      warn: 'Warn',
      error: 'Error',
      fatal: 'Fatal'
    },
    statuss: {
      all: 'All',
      new: 'New',
      confirmed: 'Confirmed'
    }
  },
  logger: {
    title: 'Operation Log',
    module: 'Business Module',
    user: 'User',
    time: 'Time',
    desc: 'Description'
  },
  // 订单管理
  order: {
    title: 'Order Management',
    payPlatform: ['Alipay', 'WeChat', 'PayPal', 'Redemption card'],
    orderStatus: ['unpaid', 'Paid', 'Failed', 'Cancelled', 'To be paid'],
    number: 'Order Number',
    desc: 'Order Details',
    time: 'Order Time',
    payTime: 'Payment Time',
    type: 'Payment Method',
    status: 'Order Status',
    cost: 'Cost',
    all: 'All',
    input: 'Please enter the order number to search...',
    pay: 'Pay',
    billing: 'Billing status',
    billingStatus: ['Unbilled', 'Application', 'Invoiced', 'Billing'],
    details: 'Order Details',
    summary: 'Order Summary',
    viewCardPack: 'View card package',
    detail: {
      number: 'Child Order Number',
      type: 'Product Type',
      detail: 'Product Details',
      cost: 'Cost (yuan)',
      typeValue: 'Renewal fee | New purchase',
      time: 'Subscription Time：{n} Months',
      total: 'Total cost',
      prodName: 'product name',
      prodAuthor: 'Author',
      prodTag: 'label',
      prodVersion: 'current version',
      prodVersionTime: 'Current version update time'
    },
    agent: 'Partner',
    agentTh: ['Promotion Code', 'Company Name', 'Company Address', 'Contact Phone', 'Discount'],
    dis: '{dis} fold'
  },
  purchase: {
    card: 'Redeem card payments can only purchase a single device',
    steps: {
      title1: 'Fill in the order',
      title2: 'Order Confirmation',
      title3: ['Payment successful', 'Payment failed', 'cancel order', 'Payments. . .'],
      license: 'License Information | Product Information',
      bind: 'Currently bound users',
      count: 'Count',
      purchaseTime: 'Purchase Time',
      origPrice: 'Market Price',
      dctPrice: 'Discount Price'
    },
    step1: {
      title: 'Purchase',
      addRenewTitle: 'Select Add renewal example',
      next: 'Order',
      addRenew: 'Add renewal fee',
      addRobot: 'Add a robot',
      bind: 'New license, unbound',
      month: '{n} months',
      proCodeErrTips: 'Please check that the recommendation code you entered is correct and has not expired. Only one recommendation code can be used for each item.',
      proCodeTips: 'You have chosen to use the referral code but it has not been applied. Click ‘Continue’ and it will be paid at the original price. Do you want to continue?',
      popUps: {
        0: 'Please confirm the package you purchased',
        1: 'As low as',
        2: 'yuan',
        3: 'Original price',
        4: 'Click to select payment method',
        5: 'Check to enter partner referral code',
        6: 'application',
        7: 'Please enter a referral code',
        8: 'Partner price'
      }
    },
    step2: {
      next: 'Confirm',
      paymentMethod: 'Payment Method',
      sub: '(subscription)',
      name: 'Machine name:',
      deadline: 'Subscription period:',
      type: 'Purchase type:',
      typeValue: 'Renewal fee | Buy'
    },
    step3: {
      next: 'Payment'
    },
    step4: {
      payment: ['支付成功', '支付失败', '取消订单', ''],
      welcome: 'Welcome to iS-RPA!',
      details: 'Details',
      instance: 'Instance'
    },
    info: {
      discount: 'Discount:',
      payable: 'Payable:',
      marketPrice: 'Market price:',
      invoice: 'If you need an invoice, please pay by this channel, we will send the invoice to your email by email.',
      license: 'Licenses are automatically renewed at each billing cycle',
      agree: 'I have read and agreed',
      protocol: 'IS-RPA User License Agreement'
    }
  }
}
